<template>
	<div class="contentBox">
		<div class="rowBox clearfix">
			<div class="titForTips">
				仓库统计
			</div>
			<div class="storeroom" v-if="warehouseList && warehouseList.length > 0">
				<div class="storeroom_list" v-for="(item, index) in warehouseList" :key="index"
					@click="goWarehouse(item)">
					<div class="storeroom_title">
						<image class="storeroom_icon" src="../../../../static/images/box@2x.png" mode=""></image>
						<div class="storeroom_name">{{ item.name }}</div>
					</div>
					<div class="storeroom_content">
						<template v-if="item.warehouseType == 0">
							<template v-if="item.totalWeight ">
								<div class="storeroom_num" v-if="item.totalWeight">{{ item.totalWeight }}</div>
							</template>
							<template v-else>
								<div class="storeroom_num">暂无</div>
							</template>
						</template>
						<template v-else>
							<template v-if="item.totalNum ">
								<div class="storeroom_num" v-if="item.totalNum">{{ item.totalNum }}</div>
							</template>
							<template v-else>
								<div class="storeroom_num">暂无</div>
							</template>
						</template>
					</div>
				</div>
			</div>
			<div class="storeroom_num storeroom" v-else>
				暂无数据
			</div>
		</div>
		<div class="rowBox clearfix">
			<div class="titForTips">
				产品数据
			</div>
			<div class="d-flex queryClass">
				<el-row :gutter="24">
					<el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
						<div class="d-flex align-items-center">
							<el-input v-model="queryParam.className" class="mb10" style="width: 240px" clearable
								placeholder="请输入产品名称"></el-input>
							<el-input v-model="queryParam.partNumber" class="mb10 ml10" style="width: 240px" clearable
								placeholder="请输入存货编码" v-if="companyName.includes('五洲')"></el-input>
							<el-radio-group v-model="queryParam.type" class="ml10 mb10" @change="handleChangeRatio">
								<el-radio-button label="date">本日</el-radio-button>
								<el-radio-button label="week">本周</el-radio-button>
								<el-radio-button label="month">本月</el-radio-button>
								<el-radio-button label="quarter">本季度</el-radio-button>
								<el-radio-button label="year">本年度</el-radio-button>
								<el-radio-button label="other">自定义</el-radio-button>
							</el-radio-group>
							<el-date-picker v-if="queryParam.type=='other'" class="mb10 ml10" v-model="queryParam.time"
								type="daterange" :picker-options="pickerOptions" range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
								clearable align="right" editable>
							</el-date-picker>
							<el-button class="ml10 mb10" type="primary" @click="handleSearch">搜索</el-button>
							<el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
							<el-button class="ml10 mb10" type="primary" @click="handleExport">导出</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="classDiv">
				<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" border>
					<el-table-column prop="inventCode" align="center" label="存货编码" v-if="companyName.includes('五洲')">
					</el-table-column>
					<el-table-column prop="className" align="center" label="产品名称">
					</el-table-column>
					<el-table-column prop="specName" align="center" label="规格">
						<template slot-scope="scope">
							{{scope.row.specName || '--'}}
						</template>
					</el-table-column>

					<el-table-column prop="inNum" align="center" label="入库数(吨)">
						<template slot-scope="scope">
							{{formatNumber(scope.row.inNum)}}
						</template>
					</el-table-column>
					<el-table-column prop="outNum" align="center" label="出库数(吨)">
						<template slot-scope="scope">
							{{formatNumber(scope.row.outNum)}}
						</template>
					</el-table-column>
					<el-table-column align="center" label="当前库存量(吨)">
						<template slot-scope="scope">
							{{calculateStock(scope.row)}}
						</template>
					</el-table-column>
				</el-table>
				<div class="pageBox">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="pageNum" :page-sizes="[10, 15, 20]"
						layout="total, sizes, prev, pager, next, jumper" class="" :total="total" :pager-count="5" />
				</div>
			</div>
		</div>
		<!-- 导出预览对话框 -->
		<el-dialog title="导出预览" width="80%" :visible.sync="exportDialogVisible" :close-on-click-modal="false"
			:destroy-on-close="true" append-to-body>
			<div class="export-tips">共 {{exportTotal}} 条数据，确认导出以下数据：</div>
			<el-table :data="exportPreviewData" style="width: 100%;margin-bottom: 20px;" border max-height="400">
				<el-table-column prop="inventCode" align="center" label="存货编码" v-if="companyName.includes('五洲')">
				</el-table-column>
				<el-table-column prop="className" align="center" label="产品名称">
				</el-table-column>
				<el-table-column prop="specName" align="center" label="规格">
					<template slot-scope="scope">
						{{scope.row.specName || '--'}}
					</template>
				</el-table-column>
				<el-table-column prop="inNum" align="center" label="入库数(吨)">
					<template slot-scope="scope">
						{{formatNumber(scope.row.inNum)}}
					</template>
				</el-table-column>
				<el-table-column prop="outNum" align="center" label="出库数(吨)">
					<template slot-scope="scope">
						{{formatNumber(scope.row.outNum)}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="当前库存量(吨)">
					<template slot-scope="scope">
						{{calculateStock(scope.row)}}
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="exportDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmExport" :loading="exportLoading">确认导出</el-button>
			</span>
		</el-dialog>
		<store-warehouse-dialog ref="storeWarehouse"></store-warehouse-dialog>
	</div>
</template>

<script>
	import {
		fetchWarehouseTj, fetchClassTj
	} from "@/api/storeWarehouse";
	import warehouseDialog from '../detailDialog/warehouseDialog'
	import accessDialog from '../detailDialog/accessDialog'
	import Search from "../../../storeLog/component/search.vue";
	import StoreWarehouseDialog from "../detailDialog/storeWarehouseDialog.vue";
	import { export_json_to_excel } from "@/excel/Export2Excel.js";
	export default {
		data() {
			return {
				userInfo: '',
				companyName: '',
				warehouseList: [],
				tableData: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
				queryParam: {
					type: "date",
					startTime: '',
					endTime: '',
					className: '',
					time: [],
					partNumber: ''
				},
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				exportDialogVisible: false,
				exportPreviewData: [],
				exportTotal: 0,
				exportLoading: false,
			}
		},
		components: {
			StoreWarehouseDialog
		},
		mounted() {
			// 默认选择本日并赋值
			this.queryParam.startTime = `${this.dateFormat(new Date(), "yyyy-MM-dd")} 00:00:00`
			this.queryParam.endTime = `${this.dateFormat(new Date(), "yyyy-MM-dd")} 23:59:59`
			this.getData()
			this.getClassData()
		},
		beforeDestroy() {

		},
		created() {
			let userInfo = JSON.parse(localStorage.getItem('info'));
			this.userInfo = userInfo
			if (this.userInfo.companyList) {
				this.companyName = this.userInfo.companyList[0].companyName
			}

		},
		methods: {
			handleChangeRatio() {
				let timeObj = {};
				let time = new Date(this.dateFormat(new Date(), "yyyy-MM-dd")); // 可入参指定时间
				let year = time.getFullYear();
				let month = time.getMonth();
				let reportDate = time.getDate(); // 获取日期
				let day = time.getDay(); // 获取周几，0-6，0表示周日
				let _day = day == 0 ? 7 : day;
				let jd = Math.ceil((month + 1) / 3);
				switch (this.queryParam.type) {
					case "date":
						this.queryParam.startTime = `${this.dateFormat(new Date(), "yyyy-MM-dd")} 00:00:00`
						this.queryParam.endTime = `${this.dateFormat(new Date(), "yyyy-MM-dd")} 23:59:59`
						break;
					case "week":
						// 获取周一日期
						var startDate = new Date(year, month, reportDate - _day + 1);
						// 获取周日日期
						var endDate = new Date(
							new Date(startDate).getTime() + 6 * 24 * 3600 * 1000
						);
						this.queryParam.startTime = `${this.dateFormat(startDate, "yyyy-MM-dd")} 00:00:00`
						this.queryParam.endTime = `${this.dateFormat(endDate, "yyyy-MM-dd")} 23:59:59`
						break;
					case "month":
						var startDate = new Date(year, month, 1);
						var endDate = new Date(year, month + 1, 0);
						this.queryParam.startTime = `${this.dateFormat(startDate, "yyyy-MM-dd")} 00:00:00`
						this.queryParam.endTime = `${this.dateFormat(endDate, "yyyy-MM-dd")} 23:59:59`
						break;
					case "quarter":
						var startDate = new Date(year, (jd - 1) * 3, 1);
						var endDate = new Date(year, jd * 3, 0);
						this.queryParam.startTime = `${this.dateFormat(startDate, "yyyy-MM-dd")} 00:00:00`
						this.queryParam.endTime = `${this.dateFormat(endDate, "yyyy-MM-dd")} 23:59:59`
						break;
					case "year":
						var startDate = new Date(year, 0, 1);
						var endDate = new Date(year, 12, 0);
						this.queryParam.startTime = `${this.dateFormat(startDate, "yyyy-MM-dd")} 00:00:00`
						this.queryParam.endTime = `${this.dateFormat(endDate, "yyyy-MM-dd")} 23:59:59`
						break;
				}
				this.getClassData()
			},
			dateFormat(date, format = 'yyyy-MM-dd hh:mm:ss') {
				if (date !== 'Invalid Date' && date != null) {
					var o = {
						'M+': date.getMonth() + 1, // month
						'd+': date.getDate(), // day
						'h+': date.getHours(), // hour
						'm+': date.getMinutes(), // minute
						's+': date.getSeconds(), // second
						'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
						'S': date.getMilliseconds() // millisecond
					}
					if (/(y+)/.test(format)) {
						format = format.replace(RegExp.$1,
							(date.getFullYear() + '').substr(4 - RegExp.$1.length))
					}
					for (var k in o) {
						if (new RegExp('(' + k + ')').test(format)) {
							format = format.replace(RegExp.$1,
								RegExp.$1.length === 1 ? o[k]
									: ('00' + o[k]).substr(('' + o[k]).length))
						}
					}
					return format
				}
				return ''
			},
			goAccess(type) {
				this.$refs.accessDialog.openDialog(type)
			},
			goWarehouse(item) {
				this.$refs.storeWarehouse.openDialog(item)
			},
			reset() {
				this.pageNum = 1
				this.queryParam.startTime = ''
				this.queryParam.endTime = ''
				this.queryParam.type = 'date'
				this.queryParam.className = ''
				this.queryParam.time = []
				this.queryParam.partNumber = ''
				this.getClassData()
			},
			getClassData() {
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				console.log('queryParam', this.queryParam.time)
				if (this.queryParam.type == 'other') {
					this.queryParam.startTime = this.queryParam.time[0]
					this.queryParam.endTime = this.queryParam.time[1]
				}
				Object.assign(param, this.queryParam)
				fetchClassTj(param).then(res => {
					// 单位换算：将非吨单位换算成吨
					this.tableData = res.data.list.map(item => {
						const convertedItem = { ...item }
						const unit = item.unit || ''
						const unitLower = unit.toLowerCase()

						// 如果单位不是吨，需要换算
						if (unitLower !== '吨' && unitLower !== 't') {
							let conversionFactor = 1

							// 根据不同单位设置换算系数（换算成吨）
							if (unitLower === 'kg' || unitLower === '千克' || unitLower === '公斤') {
								conversionFactor = 1000
							} else if (unitLower === 'g' || unitLower === '克') {
								conversionFactor = 1000000
							} else if (unitLower === '斤') {
								conversionFactor = 2000
							} else if (unitLower === 'mg' || unitLower === '毫克') {
								conversionFactor = 1000000000
							}

							// 换算数值为吨，保留四位小数
							convertedItem.inNum = item.inNum ? (item.inNum / conversionFactor).toFixed(4) : 0
							convertedItem.outNum = item.outNum ? (item.outNum / conversionFactor).toFixed(4) : 0
							convertedItem.stockNum = item.stockNum ? (item.stockNum / conversionFactor).toFixed(4) : 0
							convertedItem.unit = '吨'
						}

						return convertedItem
					})
					this.total = res.data.total
				})
			},
			getData() {
				fetchWarehouseTj().then(res => {
					if (res.code == 200) {
						this.warehouseList = res.data
					}
				})
			},
			handleSearch() {
				this.pageNum = 1
				this.getClassData()
			},
			handleSizeChange(num) {
				this.pageSize = num;
				this.pageNum = 1;
				this.getClassData();
			},
			handleCurrentChange(num) {
				this.pageNum = num;
				this.getClassData();
			},
			calculateStock(row) {
				// const inNum = parseFloat(row.inNum) || 0
				// const outNum = parseFloat(row.outNum) || 0
				const stock = parseFloat(row.stockNum) || 0
				// const stock = inNum - outNum
				// 保留四位小数，然后去除末尾的0
				return this.formatNumber(stock.toFixed(4))
			},
			// 格式化数字，去除末尾的0
			formatNumber(numStr) {
				if (!numStr) return '0'
				// 转为数字再转回字符串，自动去除末尾0
				return parseFloat(numStr).toString()
			},
			handleExport() {
				// 获取所有数据（不带分页）
				let param = {
					pageNum: 1,
					pageSize: 99999
				}
				if (this.queryParam.type == 'other') {
					// 自定义时间，添加时分秒
					param.startTime = this.queryParam.time[0] ? this.queryParam.time[0] + ' 00:00:00' : ''
					param.endTime = this.queryParam.time[1] ? this.queryParam.time[1] + ' 23:59:59' : ''
				} else {
					Object.assign(param, {
						type: this.queryParam.type,
						startTime: this.queryParam.startTime,
						endTime: this.queryParam.endTime
					})
				}
				if (this.queryParam.className) {
					param.className = this.queryParam.className
				}
				if (this.queryParam.partNumber) {
					param.partNumber = this.queryParam.partNumber
				}

				fetchClassTj(param).then(res => {
					// 单位换算
					const convertedData = res.data.list.map(item => {
						const convertedItem = { ...item }
						const unit = item.unit || ''
						const unitLower = unit.toLowerCase()

						if (unitLower !== '吨' && unitLower !== 't') {
							let conversionFactor = 1

							if (unitLower === 'kg' || unitLower === '千克' || unitLower === '公斤') {
								conversionFactor = 1000
							} else if (unitLower === 'g' || unitLower === '克') {
								conversionFactor = 1000000
							} else if (unitLower === '斤') {
								conversionFactor = 2000
							} else if (unitLower === 'mg' || unitLower === '毫克') {
								conversionFactor = 1000000000
							}

							convertedItem.inNum = item.inNum ? (item.inNum / conversionFactor).toFixed(4) : 0
							convertedItem.outNum = item.outNum ? (item.outNum / conversionFactor).toFixed(4) : 0
							convertedItem.stockNum = item.stockNum ? (item.stockNum / conversionFactor).toFixed(4) : 0
							convertedItem.unit = '吨'
						}

						return convertedItem
					})

					this.exportPreviewData = convertedData
					this.exportTotal = convertedData.length
					this.exportDialogVisible = true
				})
			},
			confirmExport() {
				this.exportLoading = true

				// 准备导出数据 - 表头（带单位）
				const th = []
				if (this.companyName.includes('五洲')) {
					th.push('存货编码')
				}
				th.push('产品名称', '规格', '入库数(吨)', '出库数(吨)', '当前库存量(吨)')

				// 准备导出数据 - 表格数据（二维数组格式，不带单位）
				const tb = this.exportPreviewData.map(item => {
					const row = []
					if (this.companyName.includes('五洲')) {
						row.push(item.inventCode || '')
					}
					row.push(item.className || '')
					row.push(item.specName || '--')
					row.push(this.formatNumber(item.inNum))
					row.push(this.formatNumber(item.outNum))
					row.push(this.calculateStock(item))
					return row
				})

				// 导出Excel
				export_json_to_excel(th, tb, '产品数据')

				this.exportLoading = false
				this.exportDialogVisible = false
				this.$message.success('导出成功')
			}
		}
	}
</script>

<style scoped>
	.queryClass {
		margin-top: 10px;
	}

	.contentBox {
		width: 100%;
		margin-bottom: 20px;

	}

	.rowBox {
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
		margin: 0 auto 20px;
		background: #fff;
	}

	.ibox {
		clear: both;
		padding: 0;
		background: #fff;
		height: auto;
		position: relative;

	}

	.titForTips {
		font-size: 18px;
		height: 40px;
		line-height: 30px;
		padding-top: 9px;
		position: relative;
		z-index: 2;

	}

	.titForTips::after {
		content: "";
		display: block;
		width: 80px;
		height: 11px;
		background: rgba(226, 234, 255, 0.5);
		position: absolute;
		z-index: -1;
		left: 25px;
		bottom: 0;
	}

	.storeroom {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
		padding-top: 48rpx;
		margin: 15px 0;
	}

	.storeroom_list {
		display: inline-block;
		width: 200px;
		background: #F5F9FC;
		border-radius: 20px;
		z-index: 99;
		position: relative;
		padding-bottom: 10px;
		cursor: pointer;
		margin-bottom: 20px;
		margin-right: 20px;
	}

	.storeroom_icon {
		width: 29px;
		height: 29px;
		margin-right: 10px;
	}

	.storeroom_title {
		width: fit-content;
		min-height: 50px;
		padding: 4px 10px;
		background: linear-gradient(143deg, #2124f7, #2CEBF7);
		border-radius: 20px 0 20px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.storeroom_name {
		font-size: 14px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #FFFFFF;
	}

	.storeroom_content {
		box-sizing: border-box;
		margin-top: 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding-left: 16px;
	}

	.storeroom_num,
	.storeroom_total {
		font-size: 16px;
		font-family: DIN;
		font-weight: 500;
		color: #6E798C;
		box-sizing: border-box;
		padding: 0 5px;
		position: relative;
	}

	.storeroom_content .storeroom_add {
		color: #4E7FFF;
		font-weight: bold;
	}

	.scansBox {
		width: 100%;
		height: auto;
		background-color: #fff;
		margin: 5px auto;
		padding: 20px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.scanItem {
		width: 50%;
		background-color: #ffffff;
		float: left;
		position: relative;
		padding-top: 35px;
		margin-top: 0;
		height: auto;
		padding-bottom: 20rpx;
	}

	.newsItems {
		width: 50%;
	}

	.dataTipsBox {
		position: absolute;
		left: 0;
		top: 0;
	}

	.tipBackImg {
		/* width: 7rem;
	    height: auto; */
		width: 112px;
		height: 30px;
		display: block;
		float: left;
	}

	.tipsTitles {
		position: absolute;
		/* left: 1.3rem;
	    top: 0.26rem; */
		left: 20px;
		top: 3px;
		color: #fff;
	}

	.codeItem {
		width: 31%;
		height: 90px;
		float: left;
		margin-right: 1%;
		margin-left: 1%;
		cursor: pointer;
	}

	.scanItem1 {
		margin-right: 10px
	}

	.scanItem2 {
		margin-left: 10px
	}

	.scanItem1 .codeItem:hover,
	.scanItem4 .codeItem:hover {
		background-color: #fefbf6;
	}

	.scanItem2 .codeItem:hover {
		background-color: #f5faf4;
	}

	.scanItem3 .codeItem:hover {
		background-color: #f5f9fb;
	}

	.forLines {
		width: 2px;
		height: 30px;
		border-left: 1px dashed #e8e8e8;
		float: left;
		margin-top: 35px;
	}

	.codeNumber {
		/* font-size: 1.75rem;
	    line-height: 3.2rem; */
		font-size: 25px;
		line-height: 35px;
		text-align: center;
		margin-top: 5px;
	}

	.codeTitle {
		font-size: 16px;
		color: #aaa;
		/* line-height: 1.8rem; */
		line-height: 25px;
		text-align: center;
	}

	.yell_Color {
		color: #FF8438;
	}

	.gre_color {
		color: #08A89B;
	}

	.nfc_color {
		color: #05c944;
	}

	.echartBox {
		width: 100%;
		height: 400px;
	}

	.rowBox1 {
		width: 100%;
		box-sizing: border-box;
		padding: 20px 0;
	}

	.classDiv {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.export-tips {
		font-size: 14px;
		color: #606266;
		margin-bottom: 15px;
		line-height: 1.5;
	}
</style>